import { Component, OnInit } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-person-fisic-form',
  templateUrl: './person-fisic-form.component.html',
  styleUrls: ['./person-fisic-form.component.scss']
})
export class PersonFisicFormComponent extends FormBaseComponent<any> implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    this.init();
  }

  template() {
    this.form.addControl('sameCommerce', new FormControl(null));
    this.form.addControl('sameFiscalAdmin', new FormControl(null));
    this.form.addControl('sameFiscalPersonal', new FormControl(null));
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/person-fisic-form/person-fisic-form.component.ts